import {withStyles} from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';

// A custom Accordion
const Accordion = withStyles(() => ({
    root: {
        border: "none",
        boxShadow: "none",
        borderRadius: 0,
        marginBottom: 5,
        '&:before': {
            display: "none"
        },
        '&$expanded': {
            margin: "auto",
            marginBottom: 5,
        }
    },
    expanded: {}
}))(MuiAccordion);

export default Accordion;